import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Col } from "reactstrap";
import { useDispatch } from "react-redux";
import {
  addByNationalsId,
  getRolesForTables,
} from "../../../slices/admin/thunk";
import Loading from "../../../Components/Loading";
import GATable from "../../../Components/Tables/GATable/GATable";
import AddRoleModal from "../../../Components/modals/GeneralModals/AddRoleModal";
import Swal from "sweetalert2";
import { DASHBOARD_USER_ROLES } from "../../../constants";
import SearchBar from "../../../Components/SearchBar/SearchBar";
import DropdownActionsTable from "../../../Components/Dropdown/DropdownActionsTable";
import { downloadGAsReportByUserId } from "../../../slices/general/thunk";
import { useCurrentUser } from "../../../slices/auth/hooks";

const DashboardGaNational = ({ gaId, isLoaded, openModal, setOpenModal }) => {
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const currentUser = useCurrentUser();
  const isAdmin = currentUser?.role === DASHBOARD_USER_ROLES.ADMIN;
  const { id } = useParams();

  const [loading, setLoading] = useState(false);

  const [loadingCreate, setLoadingCreate] = useState(false);

  const [ga, setGa] = useState([]);
  const [totalGa, setTotalGa] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);

  const [searchDone, setSearchDone] = useState(false);
  const [lastSearchTerm, setLastSearchTerm] = useState(searchTerm);

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timerId);
  }, [searchTerm]);

  const fetchGa = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        getRolesForTables({
          id: gaId || id,
          userRole: "nationals",
          role: "ga",
          page: currentPage,
          query: searchTerm,
        })
      ).unwrap();
      setGa(response.data);
      setTotalGa(response.total);
      setPageSize(response.pageSize);
      setTotalPages(response.pages);

      setLoading(false);
      setSearchDone(true);
    } catch (error) {
      setLoading(true);
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isLoaded) {
      if (debouncedSearchTerm === lastSearchTerm) {
        setSearchDone(true);
      } else {
        setSearchDone(false);
      }
      fetchGa();
    }
  }, [gaId, id, dispatch, debouncedSearchTerm, currentPage]);

  const handleCreateGA = async (values) => {
    try {
      setLoadingCreate(true);
      const response = await dispatch(
        addByNationalsId({ id: id, data: values })
      ).unwrap();
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "GA created successfully",
        timer: 2000,
        showConfirmButton: false,
      });
      setLoadingCreate(false);
      fetchGa();
      setOpenModal(false);

      setLoadingCreate(false);
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error.message || "An error occurred while adding GA",
        icon: "error",
        confirmButtonText: "OK",
      });
      setLoadingCreate(false);
      console.log(error);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  return (
    <React.Fragment>
      {openModal && (
        <AddRoleModal
          open={openModal}
          setOpen={setOpenModal}
          roleToAdd={DASHBOARD_USER_ROLES.GA}
          onCreate={handleCreateGA}
          loading={loadingCreate}
          forUserId={id}
        />
      )}
      <Container fluid>
        <div className="col-12 d-flex justify-content-between mt-2 mb-3 align-items-center ">
          <div className="col-4 d-flex justify-content-end align-items-center">
            <SearchBar
              inputRef={inputRef}
              value={searchTerm}
              onChange={handleSearch}
              placeholder="Filter by name or email"
            />
            {isAdmin && (
              <DropdownActionsTable
                downloadMethod={downloadGAsReportByUserId}
                params={{ dashboardUserId: gaId || id }}
              />
            )}
          </div>
        </div>

        <Col xl={12}>
          <div className="table-container  position-relative">
            {loading && <Loading />}
            <div className="live-preview">
              <div className="table-responsive ">
                <GATable
                  data={ga}
                  searchDone={searchDone}
                  searchParam={debouncedSearchTerm}
                  paginationProps={{
                    currentPage,
                    pageSize,
                    totalItems: totalGa,
                    totalPages,
                    onChangePage: handleChangePage,
                  }}
                />
              </div>
            </div>
          </div>
        </Col>
      </Container>
      <div id="portal-root"></div>
    </React.Fragment>
  );
};

export default DashboardGaNational;
